import React, { Component } from "react";
import classes from "./StepBar.module.css";
import { Col, Row } from "react-bootstrap";

class StepBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userType: localStorage.getItem("userType"),
    };
  }
  render() {
    let { active } = this.props;
    console.log("active", active);

    return (
      <div
        className={`${classes.gapTop} justify-content-md-center`}
        style={{ width: "68%", marginLeft: "20px", marginTop: "2px" }}
      >
        {/* <Col md={8}>
                        <div className={classes.progress}>
                            <ul>
                                <li className={(active === 'jobProfile' || active === 'selectInterviewPage' || active === 'interviewDatePage' || active === 'previewPage') && classes.isActive}>
                                    Select<br/> Job Profile
                                    <div className={classes.isActive}></div>
                                </li>
                                <li className={(active === 'selectInterviewPage' || active === 'interviewDatePage' || active === 'previewPage') && classes.isActive}>
                                    Select<br/> Interviewer
                                    <div className={active === 'selectInterviewPage' ? classes.isActive : classes.circle}></div>
                                </li>
                                <li className={active === 'previewPage' && classes.isActive}>
                                    Review and<br/> Payment
                                    <div className={active === 'previewPage' ? classes.isActive : classes.circle}></div>
                                </li>
                            </ul>
                        </div>
                    </Col> */}

        <div>
          {this.state.userType === 0 ? (
            <ul className="progress-tracker progress-tracker--text progress-tracker--text-inline progress-tracker--spaced">
              <li
                className={`progress-step ${
                  (active === "jobProfile" ||
                    active === "selectInterviewPage" ||
                    active === "interviewDatePage" ||
                    active === "paymentPreview") &&
                  "is-complete"
                }`}
              >
                <div className="progress-marker" data-text="1">
                  <div className="progress-text">
                    <h6
                      className={`progress-title ${
                        (active === "jobProfile" ||
                          active === "selectInterviewPage" ||
                          active === "interviewDatePage" ||
                          active === "paymentPreview") &&
                        "color"
                      }`}
                    >
                      Select Profile
                    </h6>
                  </div>
                </div>
              </li>

              <li
                className={`progress-step ${
                  (active === "selectInterviewPage" ||
                    active === "interviewDatePage" ||
                    active === "paymentPreview") &&
                  "is-complete"
                }`}
              >
                <div className="progress-marker" data-text="2">
                  <div className="progress-text">
                    <h6
                      className={`progress-title ${
                        (active === "selectInterviewPage" ||
                          active === "interviewDatePage" ||
                          active === "paymentPreview") &&
                        "color"
                      }`}
                    >
                      Select Interviewer
                    </h6>
                  </div>
                </div>
              </li>

              <li
                className={`progress-step ${
                  active === "paymentPreview" && "is-active"
                }`}
                aria-current="step"
              >
                <div className="progress-marker" data-text="3">
                  <div className="progress-text">
                    <h6
                      className={`progress-title ${
                        active === "paymentPreview" && "color"
                      }`}
                    >
                      Review and Payment
                    </h6>
                  </div>
                </div>
              </li>
            </ul>
          ) : null}
        </div>
      </div>
    );
  }
}

export default StepBar;
